export default __webpack_public_path__ + "static/media/new-logo.44e8bd6f.svg";